import Vue from 'vue'

// ==饿了么组件===
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


import App from './App.vue'

Vue.use(ElementUI);

import router from './routers/index.js'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')


Vue.config.productionTip = false


new Vue({
	router,
	VueAwesomeSwiper,
	VideoPlayer,
  render: h => h(App),
}).$mount('#app')
